import React from "react";
import { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
export class AddAddressDetails1 extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue: ""
        }
    }
    render(){
        return(
            <div className="details-4-col-container address-detail-container">
                <SelectField label="Location Site"  options={this.props.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                <InputField label="Address 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="Address 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="Location Type" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="City" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="State" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="Country / Location" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="ZIP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                <InputField label="Demarc Location" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
            </div>
        )
    }
}